// extracted by mini-css-extract-plugin
module.exports = {"embeddedVideoNoPadding":"EmbeddedVideo_embeddedVideoNoPadding__EchXC","embeddedVideoWithPadding":"EmbeddedVideo_embeddedVideoWithPadding__pQ9Y0"};